module.exports = __webpack_public_path__ + "static/media/banner.92f438bd.gif";